import { Skeleton } from '@mui/material';

export const SkeletonLoader = ({ length = 1 }) => {
    return Array.from({ length: length }).map((_, i) => <Skeleton key={i} sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' animation='wave' height='3rem' />);
};
